module.exports = __webpack_public_path__ + "static/media/duplicate.7d75d86a.svg";